import React from 'react';
import { connect } from 'react-redux';

import Collaborators from '../../../FieldTypes/Collaborator';
import { IRootState } from '../../../../modules/stores';
import { convertMaybeCollaboratorCellValueToGroupIdArray } from '@treelab/common-logic';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string;
}

const ElementFieldCollaborator: React.FC<IProps & IConnectProps> = ({ cell, field }) => {
  const userIds = convertMaybeCollaboratorCellValueToGroupIdArray(cell);
  if (userIds.length === 0 || !field) return null;

  return <Collaborators userIds={userIds} />;
};

const mapState = ({ core }: IRootState, { fieldId, recordId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
  field: core.fieldById[fieldId],
});

export default connect(mapState)(ElementFieldCollaborator);
